<!--
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-06-13 16:19:11
 * @LastEditors: hongye
 * @LastEditTime: 2025-09-15 20:04:35
-->
<template>
  <ConfigProvider :locale="locale" :autoInsertSpaceInButton="false">
    <router-view />
  </ConfigProvider>
</template>
<script lang="ts" setup>
  import { computed, onMounted } from 'vue'
  import { ConfigProvider } from 'ant-design-vue'
  import { useSettingStore } from '@/store'
  import { localeMap } from '@/utils'

  const sysSetting = useSettingStore()
  const locale = computed(() => localeMap[sysSetting.locale].antd)

  onMounted(() => {
    let loading = document.getElementById('preloader')
    if (loading !== null) {
      document.body.removeChild(loading)
    }
  })
</script>
<style>
  #app {
    font-family: PingFangSC, PingFangSC-Regular;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    min-width: 1200px;
  }
  .ant-table-cell:empty:after {
    content: '--';
  }
</style>
